import { api as com, apiFuns } from 'sw-hic';
let {get, post, put, del} = apiFuns

const api = {
  Hospitalization: {
    ...apiFuns.genStandard("hospitalization", "/api/ip", false, true),    
  },
  /** **********结算标准接口****************** **/
  Settlement: {
    ...apiFuns.genStandard("settlement", "/api/ip"),
    queryHospitalization: (para) => get(`/api/ip/settlement/hospitalization`, para),//1.2
    current: (ipNo) => get(`/api/ip/settlement/${ipNo}/current`),//1.3
    details: (id) => get(`/api/ip/settlement/${id}/detail`),//1.6
    run: (para) => put(`/api/ip/settlement/current`, para),//1.4
    finsh: (id) => put(`/api/ip/settlement/${id}/finish`),//1.7
    result: (id) => put(`/api/ip/settlement/${id}/result`),//1.5
    queryDetail: (id) => get(`/api/ip/settlement/${id}`),//返回和1.3一样
    queryHosp:(ipNo)=>get(`/api/ip/hospitalization/ipNo/${ipNo}`),
    cancel:(para) => put(`/api/ip/settlement/current/cancel`,para),//1.8
  },
  Billing: apiFuns.genStandard("billing", "/api/ip"),

  //获取结算列表-自定义
  getSettlementList: (data) => {
    return post(`/api/ip/settlement/list`, data);
  },
  //查询患者待结算明细
  getSettlementInfo: (data) => {
    return get(`/api/ip/settlement/settledDeposit`, data);
  },

  getInfusionList() {
    return new Promise((resolve, reject) => {
      // return get(`/api/ip/settlement/settledDeposit`,data);
      let tableData = [
        {
          1: "202204171234",
          2: "西药",
          3: "消化内科",
          4: "张医生",
          5: "203.5",
          child: [
            {
              1: "抗感染类",
              2: "头孢克肟片 ",
              3: "50mg*18s/盒  ",
              4: "1.5 ",
              5: "1.5 ",
              6: " 35.25",
              7: " 35.25",
            },
          ],
        },
        {
          1: "202204171234",
          2: "西药",
          3: "消化内科",
          4: "张医生",
          5: "203.5",
          child: [
            {
              1: "抗感染类",
              2: "头孢克肟片 ",
              3: "50mg*18s/盒  ",
              4: "1.5 ",
              5: "1.5 ",
              6: " 35.25",
              7: " 35.25",
            },
          ],
        },
      ];
      resolve({ items: tableData });
    });
  },

  /** **********主api中的接口****************** **/

  // 根据证据号查询患者信息
  getPatientByIdNo: com.getPatientByIdNo,
};

export default api;
